module.exports = __webpack_public_path__ + "static/media/Personal-effects.80051205.webp";